export default __webpack_public_path__ + "static/media/Zoo_13.a51262c4.png";